import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Facebook, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      className="bg-santomato-red py-8 border-t-4 border-black"
      data-testid="footer"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Mascot */}
          <motion.img
            src="https://customer-assets-lxgj4vgw.emergentagent.net/job_santomato-pizza/artifacts/88e60a82d32443b7_image.png"
            alt="Mascotte Santomato con smash burger"
            data-testid="footer-mascot"
            loading="lazy"
            className="w-24 md:w-28 -rotate-6"
            animate={{ y: [0, -8, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
          />
          {/* Brand */}
          <div>
            <p className="font-fredoka font-bold text-white text-lg uppercase">SANTOMATO</p>
            <p className="font-nunito text-white/80 text-sm">Pizza Lovers Since 1985</p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a 
              href="https://instagram.com/santomatopizza" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white p-2 rounded-full border-2 border-black hover:bg-santomato-yellow transition-colors"
              data-testid="footer-instagram"
              aria-label="Instagram"
            >
              <Instagram size={20} className="text-black" />
            </a>
            <a 
              href="https://facebook.com/santomatopizza" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white p-2 rounded-full border-2 border-black hover:bg-santomato-yellow transition-colors"
              data-testid="footer-facebook"
              aria-label="Facebook"
            >
              <Facebook size={20} className="text-black" />
            </a>
            <a 
              href="tel:0307992227"
              className="bg-white p-2 rounded-full border-2 border-black hover:bg-santomato-yellow transition-colors"
              data-testid="footer-phone"
              aria-label="Telefono"
            >
              <Phone size={20} className="text-black" />
            </a>
            <a 
              href="mailto:info@santomato.it"
              className="bg-white p-2 rounded-full border-2 border-black hover:bg-santomato-yellow transition-colors"
              data-testid="footer-email"
              aria-label="Email"
            >
              <Mail size={20} className="text-black" />
            </a>
          </div>

          {/* Copyright */}
          <p className="font-nunito text-white/80 text-sm text-center md:text-right">
            © {currentYear} Santomato. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
